import { combineReducers } from 'redux';

import fetchTCContentMap, {
    fetchTCContentAction,
} from './actions/fetchTCContent';
import termsAndConditionsReducerMap, {
    selectors as termsAndConditionsSelectors,
} from './appstate';
import NAMESPACE from './types';

const reducer = combineReducers({
    ...fetchTCContentMap,
    ...termsAndConditionsReducerMap,
});

export {
    fetchTCContentAction,
    termsAndConditionsSelectors,
};

export default {
    [NAMESPACE]: reducer,
};
